import {
  API,
  checkWindow,
  ErrorDetail,
  errorManager,
  ErrorService,
  generateRandomToken,
  getFromSessionStorageByKey,
  LoggerInstance,
  setItemCookie,
} from '@vfit/shared/data-access';
import { Loading } from '../Loading';
import { useEffect } from 'react';
import {
  CONSUMER_CMS_DEFAULT,
  ICGradeLoadingCMS,
  retrieveUserAgent,
  useCmsConfig,
  USER_ABROAD_COOKIE,
  useRegisterDevice,
} from '@vfit/consumer/data-access';
import { datadogRum } from '@datadog/browser-rum';
import { useCDALogin } from '@vfit/consumer/abroad';

const VerificaIdentitaNewRoaming = () => {
  const querystringParams = (checkWindow() && window.location.search) || '';
  const urlParams = new URLSearchParams(querystringParams);
  const {
    data: deviceData,
    mutate: deviceMutation,
    isSuccess: isSuccessDevice,
    isError: isErrorDevice,
    isLoading: isLoadingDevice,
  } = useRegisterDevice();
  const {
    isErrorAuthorize,
    isSuccessAuthorize,
    authorizeData,
    startAuthorize,
    startLogin,
    isSuccessCDALogin,
    isErrorCDALogin,
    loginData,
  } = useCDALogin();
  const isReturnFromAuthorize = !!urlParams?.get('code');
  const stateParams = urlParams?.get('state');
  const isDev = process.env['NODE_ENV'] === 'development';

  const { cgradeloading } =
    (useCmsConfig(CONSUMER_CMS_DEFAULT, API.CMS_GET_CGRADE_LOADING) as ICGradeLoadingCMS) || {};

  const showError = () => {
    sessionStorage?.clear();
    const errorGeneric: ErrorDetail = {
      message: 'Si è verificato un errore.',
      title: 'Ops',
      actionEvent: () => {
        if (checkWindow()) {
          window.location.href = '/';
        }
      },
      actionText: 'Chiudi',
    };
    errorManager.handleError(ErrorService.getSeverityErrorHigh(), errorGeneric);
  };

  const redirectToAbroadPage = () => {
    const newRoamingParams = getFromSessionStorageByKey('CDAParams');
    if (!newRoamingParams?.redirect_uri) {
      window.location.href = `${window.location.origin}/tariffe-estero`;
    }
    const urlToRedirect = new URL(`${newRoamingParams?.redirect_uri}`);
    datadogRum.addAction('CDA NEW ROAMING PARAMS', {
      type: 'CONSUMER',
      url: window.location.href,
      params: newRoamingParams,
    });
    if (checkWindow()) {
      sessionStorage.removeItem('CDAParams');
      if (isDev) {
        alert(`Redirect to: ${urlToRedirect.toString()}`);
      } else {
        window.location.replace(urlToRedirect.toString());
      }
    }
  };

  useEffect(() => {
    if (isErrorCDALogin || (isSuccessCDALogin && !(loginData as any)?.body)) {
      showError();
    } else if (isSuccessCDALogin && loginData) {
      const user = (loginData as any).body;
      const userMsisdn = user?.msisdn || user?.items?.[0]?.value || '';
      const userMsisdns =
        user?.items?.filter?.((el) => el?.type?.toLowerCase() === 'sim').map((s) => s.value) || [];
      const isUserLegacy = !user?.isNext || false;
      const cookieObj = {
        msisdn: userMsisdn,
        customerId: user?.customerId || '',
        contactId: user?.contactId || '',
        deviceId: deviceData?.installationId || '',
        msisdns: userMsisdns,
        isLegacy: isUserLegacy,
        isEnriched: false,
      };
      setItemCookie(USER_ABROAD_COOKIE, JSON.stringify(cookieObj), 1, !isDev);
      LoggerInstance.debug('USER: Set cookie', cookieObj);
      redirectToAbroadPage();
    }
  }, [isSuccessCDALogin, isErrorCDALogin]);

  useEffect(() => {
    if (isErrorDevice) {
      showError();
    } else if (isSuccessDevice) {
      startLogin({
        endpoint: 'onboarding/loginApp',
        code: urlParams?.get('code') || '',
        deviceId: deviceData?.installationId || '',
        deviceUserAgent: retrieveUserAgent(),
        redirectUri: window?.location?.href?.split('?')?.[0] || '',
      });
    }
  }, [isLoadingDevice, isErrorDevice, isSuccessDevice]);

  useEffect(() => {
    if (!isErrorAuthorize && isSuccessAuthorize && authorizeData?.url) {
      const urlToRedirect = new URL(authorizeData?.url);
      urlToRedirect.searchParams.append('redirect_uri', window.location.href?.split('?')?.[0]);
      if (isDev) {
        alert(`Redirect to: ${urlToRedirect.toString()}`);
      } else window.location.href = urlToRedirect.toString();
    } else if (isErrorAuthorize) {
      showError();
    }
  }, [isErrorAuthorize, isSuccessAuthorize, authorizeData]);

  const initNewRoamingCDA = () => {
    if (isReturnFromAuthorize) {
      const state = sessionStorage.getItem('state');
      if (state !== stateParams) {
        LoggerInstance.info('Vf state mismatch');
        showError();
      } else {
        deviceMutation();
      }
    } else {
      const newRoamingParams = {
        type: urlParams.get('type'),
        redirect_uri: urlParams.get('redirect_uri'),
      };
      sessionStorage.setItem('CDAParams', JSON.stringify(newRoamingParams));
      datadogRum.addAction('CDA NEW ROAMING LOGIN PARAM', {
        type: 'CONSUMER',
        url: window.location.href,
        params: {
          type: urlParams.get('type'),
          redirect_uri: urlParams.get('redirect_uri'),
        },
      });
      const randomState = generateRandomToken();
      sessionStorage.setItem('state', randomState);
      startAuthorize({
        state: randomState,
        endpoint: 'onboarding/authorize',
      });
    }
  };

  useEffect(() => {
    initNewRoamingCDA();
  }, []);

  return <Loading lottieOrSvg={cgradeloading?.login?.lottie} />;
};

export default VerificaIdentitaNewRoaming;
